import { MetricCard } from "@/components/dashboard_campaigns/metric-card";

import { useCampaignStore, useCreatorsStore } from "@/stores";
import { useEffect, useState } from "react";

export default function AnalyticsBar() {
  const { creators } = useCreatorsStore();
  const { campaign } = useCampaignStore();
  const [totalCreators, setTotalCreators] = useState(0);
  const [creatorDeclined, setCreatorDeclined] = useState(0);
  const [replies, setReplies] = useState(0);

  const [_pendingOutreach, setPendingOutreach] = useState(0);
  const [activatedCreators, setActivatedCreators] = useState(0);
  const [nonContacted, setNonContacted] = useState(0);

  useEffect(() => {
    setTotalCreators(creators.length);

    // Count creators by status
    const declined = creators.filter(
      (creator) => creator.status === "creator-declined"
    ).length;
    const repl = creators.filter(
      (creator) =>
        creator.status != "pending-outreach" &&
        creator.status != "pending" &&
        creator.status &&
        creator.status != "outreached" &&
        creator.status != "to-contact"
    ).length;

    const pending_outreach = creators.filter(
      (creator) => creator.status === "pending-outreach"
    ).length;
    // When a campaign has stages, the creator's status becomes a stage UUID
    // after approval (instead of "activated") and ends at "completed". So
    // every stage UUID, plus "completed", counts as activated.
    const activatedStatuses = new Set<string>([
      "waiting-approval",
      "pending-activation",
      "activated",
      "completed",
      ...(campaign?.stages ?? []).map((s) => s.id),
    ]);
    const activated = creators.filter(
      (creator) => creator.status && activatedStatuses.has(creator.status)
    ).length;
    const non_contacted = creators.filter(
      (creator) =>
        creator.status === "pending-outreach" ||
        creator.status === "pending" ||
        creator.status === "to-contact"
    ).length;

    setCreatorDeclined(declined);
    setReplies(repl);

    setPendingOutreach(pending_outreach);
    setActivatedCreators(activated);
    setNonContacted(non_contacted);
  }, [creators, campaign?.stages]);

  // Calculate metrics
  const contactedCreators = totalCreators - nonContacted;

  const contactedCreatorsPerc =
    totalCreators > 0
      ? ((contactedCreators / totalCreators) * 100).toFixed(1)
      : "0.0";
  const replyPerc =
    contactedCreators > 0
      ? ((replies / contactedCreators) * 100).toFixed(1)
      : "0.0";
  const activatedPerc =
    replies > 0 ? ((activatedCreators / replies) * 100).toFixed(1) : "0.0";
  const declinedPerc =
    replies > 0 ? ((creatorDeclined / replies) * 100).toFixed(1) : "0.0";

  return (
    <div className="grid xl:grid-cols-4 grid-cols-2 divide-x-0 xl:divide-x w-full">
      <MetricCard
        value={contactedCreators}
        total={totalCreators}
        label="Contacted"
        tooltip="Contacted creators for this campaign"
        percentage={contactedCreatorsPerc}
        color="emerald"
      />

      <MetricCard
        value={replies}
        total={contactedCreators}
        label="Reply Rate"
        tooltip="Creators who replied to outreach"
        percentage={replyPerc}
        color="blue"
      />

      <MetricCard
        value={activatedCreators}
        total={replies}
        label="Activation Rate"
        tooltip="Creators who got activated after replying"
        percentage={activatedPerc}
        color="amber"
      />

      <MetricCard
        value={creatorDeclined}
        total={replies}
        label="Declined"
        tooltip="Creators who declined after replying"
        percentage={declinedPerc}
        color="rose"
      />
    </div>
  );
}
